import { ActionTypes } from "./types";

let INITIAL_STATE = {
  data: [],
  loading: false,
  success: false,
  error: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.LOADING:
      return {
        ...state,
        loading: true,
      };

    case ActionTypes.SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
      };

    case ActionTypes.CREATE_CUSTOM_SUCCESS:
      return {
        ...state,
        data: [
          ...state.data,
          action.payload
        ],
        loading: false,
        success: true,
      };

    case ActionTypes.DELETE_CUSTOM_SUCCESS:
      return {
        ...state,
        data: [
          ...state.data.filter((item: any) => item.value !== action.payload)
        ],
        loading: false,
        success: true,
      };

    case ActionTypes.ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
